<template>
    <div class="message-layer" v-if="isShow">
        <div class="message-content">
            <div class="message-main">
                <div class="main-wrap">
                    <i :class="`icon icon-message icon-${type}`"></i>
                    <div class="message-tip">
                        <div class="text-box" v-html="tip"></div>
                    </div>
                    <a class="btn-item btn-result" href="javascript: void(0)" v-if="type === 'success' || type === 'examine'" @click="toResult">查看我的礼品</a>
                    <slot name="confirmBtn" v-if="type === 'confirm'"></slot>
                </div>
            </div>
            <div class="btn-wrap">
                <router-link tag="a" class="btn-item btn-continue" to="/member/shop/index" v-if="type === 'success' || type === 'examine'">继续兑换</router-link>
                <a class="btn-item btn-close" href="javascript: void(0)" @click="closeLayer" v-if="type === 'error'">关闭</a>
                <a class="btn-item btn-close" href="javascript: void(0)" @click="closeLayer" v-if="type === 'confirm'">再考虑下</a>
            </div>
            <a class="icon icon-close" href="javascript: void(0)" @click="closeLayer"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Message',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'success'
            },
            tip: {
                type: String,
                default: ''
            }
        },
        methods: {
            closeLayer () {
                this.$emit('on-close', false)
            },
            toResult () {
                this.$emit('on-result', false)
            }
        }
    }
</script>

<style lang="less" scoped>
    .message-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        .message-content{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 320px;
            height: 269px;
            padding: 32px 30px;
            margin-top: -135px;
            margin-left: -160px;
            background-color: #fff;
            border: #d3dadd solid 1px;
            border-radius: 4px;
            .message-main{
                height: 181px;
                &::before{
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: 0;
                    height: 100%;
                }
                .main-wrap{
                    display: inline-block;
                    vertical-align: middle;
                    width: 100%;
                }
            }
            .icon-message{
                display: block;
                width: 64px;
                height: 64px;
                margin: 0 auto;
                &.icon-success{
                    background: url("../../assets/images/ok.png");
                    background-size: 100% 100%;
                }
                &.icon-examine{
                    background: url("../../assets/images/examine.png");
                    background-size: 100% 100%;
                }
                &.icon-confirm{
                    background: url("../../assets/images/confirm.png");
                    background-size: 100% 100%;
                }
                &.icon-error{
                    background: url("../../assets/images/error.png");
                    background-size: 100% 100%;
                }
            }
            .message-tip{
                height: 44px;
                margin-top: 7px;
                font-size: 0;
                &::before{
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: 0;
                    height: 100%;
                }
                .text-box{
                    display: inline-block;
                    vertical-align: middle;
                    width: 100%;
                    font-size: 16px;
                    line-height: 22px;
                    text-align: center;
                }
            }
            .btn-result, .btn-confirm{
                display: block;
                width: 200px;
                height: 46px;
                margin: 20px auto 0;
                background-color: #fbc500;
                font-size: 16px;
                line-height: 46px;
                text-align: center;
            }
            .btn-wrap{
                padding-top: 6px;
                text-align: center;
                color: #4a90e2;
                line-height: 24px;
            }
            .icon-close {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 29px;
                height: 29px;
                background: url("../../assets/images/close.png") no-repeat center center #d3dadd;
                background-size: 16px 16px;
                border-radius: 50%;
            }
        }
    }
</style>
